/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_IntroInputs */

const en_to_xml_intro = /** @type {(inputs: To_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON into a well formed XML document for SOAP endpoints, legacy integrations, and tools that still expect angle brackets. Keys become elements and array items become repeated siblings.`)
};

const ko_to_xml_intro = /** @type {(inputs: To_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOAP 엔드포인트, 레거시 연동, 여전히 꺾쇠괄호를 기대하는 도구를 위해 JSON을 잘 구성된 XML 문서로 변환합니다. 키는 요소가 되고 배열 항목은 반복되는 형제 요소가 됩니다.`)
};

const ja_to_xml_intro = /** @type {(inputs: To_Xml_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOAP エンドポイント、レガシー連携、いまも山かっこを期待するツールのために、JSON を整形式の XML 文書へ変換します。キーは要素になり、配列の項目は繰り返される兄弟要素になります。`)
};

/**
* | output |
* | --- |
* | "Convert JSON into a well formed XML document for SOAP endpoints, legacy integrations, and tools that still expect angle brackets. Keys become elements and ar..." |
*
* @param {To_Xml_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_intro = /** @type {((inputs?: To_Xml_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_intro(inputs)
	if (locale === "ko") return ko_to_xml_intro(inputs)
	return ja_to_xml_intro(inputs)
});